import React from 'react';
import PortWeb from './components/port';
import './index.css';

function App() {
  return (
    <div className="App">
      <PortWeb />
    </div>
  );
}

export default App;